import { type UseQueryResult, useQuery } from 'react-query';
import { PoolService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetSharePoolOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const sharePoolOptions = useQuery(
    ['getSharePoolOptions'],
    async () => {
      return await handleRequest(PoolService.getApiAwardApiAppPoolPoolListForDropdown());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return sharePoolOptions;
};

export default useGetSharePoolOptions;
